import api from './common';

export const updateUserSettings = (data) => api.post('/user-settings/', data);
